module.exports = {
      id: "icon-payment-usage",
      viewBox: "0 0 59 56",
      url: __webpack_public_path__ + "../resources/views/web/layout/partials/svg-icons.blade.php#icon-payment",
      toString: function () {
        return this.url;
      }
    }